<template>
  <div>
    <partnerSchedule
      :partners="partners"
      :programPartnerSchedules="programPartnerSchedules"
      :programs="programs"
      :programBatchCourseFees="programBatchCourseFees"
      :batches="batches"
      @getPrgPartnerSchedule="getPrgPartnerSchedule"
      @getProgramCourseFee="getProgramCourseFee"
      @getBatches="getBatches"
      :batch_id="Number(batch_id)"
    />
  </div>
</template>

<script>
import partnerSchedule from "@/components/batches/schedule.vue";

export default {
  components: { partnerSchedule },
  data() {
    return {
      programPartnerSchedules: [],
      programs: [],
      partners: [],
      batch_id: null,
      programBatchCourseFees: [],
      batches: [],
      batch: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [
      { text: "Batches", to: { name: "Batches" } },
      { text: "Partner Admission Schedule" },
    ]);

    this.batch_id = this.$route.query.batch_id;
    this.initialise();
  },
  methods: {
    async initialise() {
      await this.getBatches();
      await Promise.all([
        this.getPrgPartnerSchedule(),
        this.getPrograms(),
        this.getProgramPartners(),
        this.getProgramCourseFee(),
      ]);
    },
    async getBatches() {
      await this.$axios
        .get("program_batches")
        .then((res) => {
          const batch_data = res.data.data;
          this.batches = batch_data.filter(
            (batch) => batch.id == this.batch_id
          );
          this.batch = this.batches.find((batch) => batch.id == this.batch_id);

          this.$store.commit("setBreadcrumbs", [
            { text: "Batches", to: { name: "Batches" } },
            {
              text: `${this.batch.year} - ${this.batch.batch}`,
            },
          ]);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },

    async getProgramCourseFee() {
      await this.$axios
        .get("batch_partner_course_fees?program_batch_id=" + this.batch_id)
        .then((res) => {
          this.programBatchCourseFees = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getProgramPartners() {
      await this.$axios
        .get("get_program_partners/" + this.batch.program_id)
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrgPartnerSchedule() {
      await this.$axios
        .get("batch_partner_schedules?program_batch_id=" + this.batch_id)
        .then((res) => {
          const schedules = res.data.data;
          this.programPartnerSchedules = schedules
            .filter((c) => c.program_batch_id == this.batch_id)
            .sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
